import { GetterTree, MutationTree } from 'vuex';
import { State } from '../types/tags';

export const state: () => State = () => ({
  tempData: null,
});

export const getters: GetterTree<State, Record<string, unknown>> = {
  getTempData: state => state.tempData,
};

export const mutations: MutationTree<State> = {
  setTempData(state, value: State['tempData']) {
    state.tempData = {
      tags: {
        items: value?.tags.items || null,
        pager: value?.tags.pager || null,
      },
    };
  },
  resetTempData(state) {
    state.tempData = null;
  },
};
